//@ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { _baseRequest, COMMON } from "../../../utils/baseApi";
import { getColorForLabel } from "../../../utils/colorUtils";
import {
  ExclamationIcon,
  MeetingIcon,
  NotebookIcon,
  ReviewIcon,
} from "../../icons/Icons";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import LoadingBar from "react-top-loading-bar";

const InboxDetails = [
  { id: "all", name: "All" },
  // { id: 'scorecard', name: 'Scorecard' },
  { id: "questionnaire", name: "Questionnaire" },
  { id: "meeting", name: "Meeting" },
  { id: "review", name: "Review" },
];

function TaskListing() {
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const [allTaskItem, setAllTaskItem] = useState({
    task: [],
    totalTask: 0,
    currentPage: 1,
    hasNextPage: false,
    limit: 25,
    totalPages: 1,
  });
  const [isLoading, setIsLoading] = useState(false);

  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [selected, setSelected] = useState(InboxDetails[0]);
  const navigate = useNavigate();
  const loadingBarRef = useRef(null);

  const getSenderDetails = (item) => {
    // Default return object
    const defaultDetails = {
      image: null,
      name: null,
    };

    // If msg_user_id exists, find in baseMembers
    if (item.assigned_to) {
      const senderUser =
        baseMembers.find((member) => member.user_id === item.assigned_to) || {};
      return {
        image: senderUser.profile_pic || null,
        name: senderUser.name || null,
      };
    }

    return defaultDetails;
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/task.list?page=1&limit=${allTaskItem.limit}`;

      // select

      if (jobId) {
        fullUrl += `&job_id=${jobId}`;
      }

      if (selected.id === "scorecard") {
        fullUrl += `&type=scorecard`;
      } else if (selected.id === "questionnaire") {
        fullUrl += `&type=questionnaire`;
      } else if (selected.id === "meeting") {
        fullUrl += `&type=meeting`;
      } else if (selected.id === "review") {
        fullUrl += `&type=review`;
      }
      try {
        setIsLoading(true);
        loadingBarRef.current.continuousStart();
        const response = await _baseRequest(fullUrl, "GET");

        if (response?.data?.task && response?.data?.task?.length > 0) {
          setAllTaskItem(response?.data);
        } else {
          setAllTaskItem({
            task: [],
            totalTask: 0,
            currentPage: 1,
            hasNextPage: false,
            limit: 25,
            totalPages: 1,
          });
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsLoading(false);
        loadingBarRef.current.complete();
      }
    };

    if (baseId) {
      fetchInitialData();
    }
  }, [baseId, selected]);

  const formatDueDate = (dateString) => {
    const dueDate = new Date(dateString);
    const today = new Date();

    // Reset time portion for date comparison
    today.setHours(0, 0, 0, 0);
    const dueDateNoTime = new Date(dueDate);
    dueDateNoTime.setHours(0, 0, 0, 0);

    // Format the date part
    const monthDay = dueDate.toLocaleString("default", {
      month: "short",
      day: "numeric",
    });
    const weekday = dueDate.toLocaleString("default", { weekday: "long" });

    // Check if date is today
    if (dueDateNoTime.getTime() === today.getTime()) {
      return (
        <div className="flex flex-row gap-x-1 items-center">
          <span>{monthDay}</span>
          <span className="text-gray-500 text-xs">Today</span>
        </div>
      );
    }
    // Check if date is overdue
    else if (dueDateNoTime < today) {
      return (
        <div className="flex flex-row gap-x-1 items-center">
          <span>{monthDay}</span>
          <span className="text-red-500 text-xs">(Overdue)</span>
        </div>
      );
    }
    // Regular future date
    else {
      return (
        <div className="flex flex-row gap-x-1 items-center">
          <span>{monthDay}</span>
          <span className="text-gray-500 text-xs">{weekday}</span>
        </div>
      );
    }
  };

  const handleLoadMore = async () => {
    if (!allTaskItem.hasNextPage) return;

    const nextPage = allTaskItem.currentPage + 1;
    let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/task.list?page=${nextPage}&limit=${allTaskItem.limit}`;

    if (jobId) {
      fullUrl += `&job_id=${jobId}`;
    }

    try {
      setIsLoadingMore(true);
      const response = await _baseRequest(fullUrl, "GET");

      if (response?.data?.task && response?.data?.task?.length > 0) {
        setAllTaskItem((prev) => ({
          ...response.data,
          task: [...prev.task, ...response.data.task], // Append new tasks to existing ones
        }));
      }
    } catch (error) {
      console.error("Error loading more data:", error);
    } finally {
      setIsLoadingMore(false);
    }
  };

  const handleSelectionChange = (item) => {
    setSelected(item);
  };

  function classNames(...classes: any) {
    return classes.filter(Boolean).join(" ");
  }

  const handleApplicationDetails = (data) => {
    if (data?.type === "overview") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/overview`);
    }
    if (data?.type === "normal") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/overview`);
    }
    if (data?.type === "resume") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/resume`);
    }
    if (data?.type === "message") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/message`);
    }
    if (data?.type === "files") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/files`);
    }
    if (data?.type === "team-discussion") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/team-discussion`);
    }
    if (data?.type === "scorecard") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/scorecards`);
    }
    if (data?.type === "notes") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/notes`);
    }
    if (data?.type === "questionnaire") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/questionnaire`);
    }
    if (data?.type === "meeting") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/meetings`);
    }
    if (data?.type === "review") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/appreview`);
    }
    if (data?.type === "journey") {
      navigate(`/${baseId}/job/${jobId}/app/${data?.app_id}/journey`);
    }
  };

  return (
    <div className="mt-[0px] h-[calc(100vh_-_62px)]  overflow-y-auto py-[32px] ring-1 lg:ring-zinc-950/5 shadow-xs rounded-tl-none rounded-tr-lg rounded-bl-none rounded-br-lg p-4">
      <LoadingBar color="#ff591e" ref={loadingBarRef} />

      <div className="w-full max-w-[710px] mx-auto">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-medium text-gray-900">Task List </h2>

          <div className="flex flex-1 justify-end">
            <Listbox value={selected} onChange={handleSelectionChange}>
              <div className="relative z-10">
                <ListboxButton
                  className="relative w-[140px] rounded-md bg-white py-1.5 px-[10px] text-left text-gray-900
          focus:outline-none  text-[14px] sm:leading-4 border border-solid border-[#e7e7e8] font-medium cursor-pointer"
                >
                  <div className="flex items-center gap-1.5 justify-between">
                    <span className="block truncate">{selected.name}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="size-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m19.5 8.25-7.5 7.5-7.5-7.5"
                      />
                    </svg>
                  </div>
                </ListboxButton>
                <ListboxOptions
                  className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[140px] min-w-[140px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 
          "
                >
                  {InboxDetails.map((item) => (
                    <ListboxOption
                      key={item.id}
                      value={item}
                      className={({ active }) =>
                        classNames(
                          active
                            ? "bg-gray-200 text-[#1d2025]"
                            : "text-gray-900",
                          "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                        )
                      }
                    >
                      <span className="block truncate font-normal">
                        {item.name}
                      </span>
                    </ListboxOption>
                  ))}
                </ListboxOptions>
              </div>
            </Listbox>
          </div>
        </div>

        <div className="bg-[#e0e0e0] w-full h-[1px] mb-[34px] mt-7"></div>

        <div className="bg-white rounded-lg overflow-hidden border border-solid border-[#0009321f]">
          {/* Header Row */}
          <div className="grid grid-cols-10 gap-4 px-6 py-3 bg-[#00005506] border-b border-gray-200">
            <div className="col-span-5 font-semibold text-[#1c2024] text-sm">
              Task name
            </div>
            <div className="col-span-3 font-semibold text-[#1c2024] text-sm">
              Assigned to
            </div>
            <div className="col-span-2 font-semibold text-[#1c2024] text-sm">
              Due date
            </div>
            {/* <div className="col-span-2 font-medium text-gray-500 text-sm">Priority</div> */}
          </div>

          {isLoading ? (
            <div className="flex items-center justify-center h-[calc(100vh_-_380px)] w-full">
              <div className="simple-spinner-loader">
                <span></span>
              </div>
            </div>
          ) : !allTaskItem?.task?.length ? (
            <div
              className="w-full mt-0 flex justify-center items-center flex-col gap-y-3"
              style={{ height: "calc(100vh - 380px)" }}
            >
              <ExclamationIcon />
              <p className="text-[#0000007a] text-[13px]">No task found</p>
            </div>
          ) : (
            // Your existing list rendering code
            allTaskItem.task &&
            allTaskItem.task.map((task, index) => {
              // const cleanedTimeAgo = getShortFormTimeAgo(take.due_by);
              const { image, name } = getSenderDetails(task);
              return (
                <div
                  key={index}
                  className="grid grid-cols-10 gap-4 px-6 py-4  border-b border-[#0009321f]"
                >
                  <div
                    onClick={() => handleApplicationDetails(task)}
                    className="col-span-5 flex items-center"
                  >
                    <div className="flex-shrink-0 mr-4">
                      {/* {
                        task.type === 'scorecard' && <ScoreCardIcon />
                      } */}
                      {task.type === "questionnaire" && <NotebookIcon />}
                      {task.type === "meeting" && <MeetingIcon />}
                      {task.type === "review" && <ReviewIcon />}
                      {task.type === "normal" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-brand-asana  w-[1rem] h-[1rem] text-[#808080]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                          <path d="M17 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                          <path d="M7 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                        </svg>
                      )}
                    </div>
                    <p className=" text-[#1b1b1b] text-[13px] font-normal line-clamp-2 ">
                      {task.title}
                    </p>
                  </div>

                  <div
                    onClick={() => handleApplicationDetails(task)}
                    className="col-span-3 flex items-center"
                  >
                    {name && (
                      <div className="flex items-center gap-x-2">
                        {image ? (
                          <img
                            src={`${process.env.REACT_APP_API_BASE_URL}/${image}`}
                            alt={`${"Profile"}`}
                            className="h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10"
                          />
                        ) : (
                          <div
                            style={{
                              backgroundColor: getColorForLabel(
                                name?.charAt(0),
                              ),
                            }}
                            className="w-5 h-5 rounded-full flex items-center justify-center"
                          >
                            <span className="font-medium text-white mt-[0px] leading-5">
                              {name?.charAt(0)}
                            </span>
                          </div>
                        )}
                        {name && (
                          <p className="text-dark-black-200 overflow-hidden text-ellipsis line-clamp-1  text-[13px] capitalize">
                            {name}
                          </p>
                        )}
                      </div>
                    )}
                  </div>

                  <div
                    onClick={() => handleApplicationDetails(task)}
                    className="col-span-2 flex items-center"
                  >
                    <span className="text-sm text-gray-500">
                      {formatDueDate(task.due_by)}
                    </span>
                  </div>
                </div>
              );
            })
          )}

          {/* Pagination */}
          {allTaskItem.hasNextPage && (
            <div className="px-4 py-3 flex items-center justify-center">
              <button
                onClick={handleLoadMore}
                disabled={isLoadingMore}
                className="text-blue-500 leading-5 text-[12px] rounded-[60px] py-1 hover:ring-1 px-3 ring-inset ring-gray-500/10"
              >
                {isLoadingMore ? (
                  <span className="flex items-center gap-x-2">
                    <div className="simple-spinner-load">
                      <span></span>
                    </div>
                    Load More
                  </span>
                ) : (
                  "Load More"
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TaskListing;
